import { TableRow } from "@/components/ui/table";
import { cn } from "@/lib/cn";

import { CategoryCell } from "./CategoryCell";
import { PersonCell } from "./PersonCell";
import { ProgressCell } from "./ProgressCell";
import type { CategoryData, ColumnIndexer, TableRowData } from "./types";

interface DataRowProps {
  row: TableRowData;
  rowIndex: number;
  categories: CategoryData[];
  hoveredRowIndex: number | null;
  hoveredColIndex: number | null;
  handleRowClick: (id: string) => void;
  handleCellMouseEnter: (rowIndex: number, colIndex: number) => void;
  handleCellMouseLeave: () => void;
  columnIndexer: ColumnIndexer;
}

export const DataRow = ({
  row,
  rowIndex,
  categories,
  hoveredRowIndex,
  hoveredColIndex,
  handleRowClick,
  handleCellMouseEnter,
  handleCellMouseLeave,
  columnIndexer,
}: DataRowProps) => {
  return (
    <TableRow
      className={cn(
        "cursor-pointer bg-white",
        hoveredRowIndex === rowIndex && "bg-neutral-gray-light-3",
      )}
      onClick={() => handleRowClick(row.id)}
      onMouseEnter={() => handleCellMouseEnter(rowIndex, 0)}
      onMouseLeave={handleCellMouseLeave}
    >
      <PersonCell
        row={row}
        rowIndex={rowIndex}
        hoveredRowIndex={hoveredRowIndex}
        handleCellMouseEnter={handleCellMouseEnter}
      />
      <ProgressCell
        row={row}
        rowIndex={rowIndex}
        hoveredRowIndex={hoveredRowIndex}
        handleCellMouseEnter={handleCellMouseEnter}
      />
      {categories.flatMap((largeCategory, _largeCatIndex) =>
        largeCategory.mediumCategories.map(
          (mediumCategory, _mediumCatIndex) => {
            const colIndex = columnIndexer.getCategoryColumnIndex(
              largeCategory,
              mediumCategory,
            );

            return (
              <CategoryCell
                key={`${row.id}_${largeCategory.code}_${mediumCategory.code}`}
                row={row}
                rowIndex={rowIndex}
                colIndex={colIndex}
                largeCategory={largeCategory}
                mediumCategory={mediumCategory}
                hoveredRowIndex={hoveredRowIndex}
                hoveredColIndex={hoveredColIndex}
                handleCellMouseEnter={handleCellMouseEnter}
                handleCellMouseLeave={handleCellMouseLeave}
              />
            );
          },
        ),
      )}
    </TableRow>
  );
};
